import Vue from 'vue'
import { addCurParamsForUrl } from '@/utils/utils.js'
import openPageInI18NThs from './openPageInI18NThs'
import openPageInThs from './openPageInThs'

Vue.prototype.$addCurParamsForUrl = addCurParamsForUrl
Vue.prototype.$openPageInI18NThs = openPageInI18NThs
Vue.prototype.$openPageInThs = openPageInThs
